import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import moment from 'moment';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';
import cyan from '@material-ui/core/colors/cyan';
import grey from '@material-ui/core/colors/grey';
import ActionPlay from '@material-ui/icons/PlayCircleFilled';
import PlaylistPlay from '@material-ui/icons/PlaylistPlay';
import CloseIcon from '@material-ui/icons/Close';
import EventIcon from '@material-ui/icons/Event';
import IconButton from '@material-ui/core/IconButton';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Avatar from '@material-ui/core/Avatar';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  hour: {backgroundColor:cyan[100], padding:2, color: '#111'},
  avatar: {
    marginLeft: 8,
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,.08)',
  },
  datePicker: {
    zIndex: '2147483647 !import'
  },
}
class Programs extends React.Component {
  constructor(props) {
    super(props);
    const minDate = new Date();
    const maxDate = new Date();
    minDate.setDate(minDate.getDate() - 31);
    minDate.setHours(0, 0, 0, 0);
    maxDate.setDate(maxDate.getDate() + 6);
    maxDate.setHours(0, 0, 0, 0);
    this.state = {
      minDate: minDate,
      maxDate: maxDate,
      open: false,
      targetDate: new Date(),
      programs: []
    };
    moment.locale('ja', {
      weekdaysShort: ["日","月","火","水","木","金","土"]
    });
    // this.activeRef = React.createRef()
    // this.listRootRef = React.createRef()
  }

  handleMouseEnterOrMouseMove = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(true);
  };
  handleMouseLeave = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    if (!this.state.open) {
      this.props.onOverlayFixed(false);
    }
  };
  handleClose = () => {
    this.setState({open:false});
    this.props.onOverlayFixed(false);
  };
  handleChange = (value) => {
    console.log('handleChange');
    this.fetchIndexes(this.state.targetDate, this.props.services.services[value]);
  };
  handleDateChange = momentDate => {
    let date = new Date(momentDate.valueOf());
    date.setHours(4);
    this.fetchIndexes(date);
  }
  handleOpenButtonClick = () => {
    this.fetchIndexes(new Date());
    this.setState({open: true});
    this.props.onOverlayFixed(true);
  };
  componentWillMount = () => {
    this.setState({service: this.props.service});
  };
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.service && (!this.state.service || !this.state.open)) {
      //this.setState({service: nextProps.service});
      if (this.state.service !== nextProps.service) {
        this.fetchIndexes(this.state.targetDate, nextProps.service);
      }
    }
    if (nextProps.isFullscreen) {
      this.setState({open: false});
    }
  };
  fetchIndexes = (targetDate, service) => {
    const programGuide = this.props.programGuide;
    if (service) {
      this.setState({service: service});
    }
    else {
      service = this.state.service;
    }
    const channelId = service.original_network_id +"."+service.transport_stream_id +"."+service.service_id;
    if (!targetDate) {
      targetDate = this.state.targetDate;
    }
    if (0 <= targetDate.getHours() && targetDate.getHours() < 4) {
      targetDate.setDate(targetDate.getDate() - 1);
      targetDate.setHours(4);
    }
    const date = moment(targetDate.getTime()).format('YYYYMMDD'); //yyyymmdd
    const hour = '04';
    const duration = '1d';
    //http(s)://{EPG}/apps/epg/provider/{nid}.{tsid}.{sid}/{yyyy}{mm}{dd}/{hh}/{duration}.json
    var url = programGuide.index.base[0] +'/' +channelId +'/' +date +'/' +hour +'/' +duration +'.json';
    var self = this;
    $.ajax({
      method:'get',
      url: url,
      dataType: 'json',
      cache: false,
      success: (data) => self.fetchItems(targetDate, data.event_id_list),
      error: (xhr, status, err) => console.error(url, status, err.toString())
    });
  };
  fetchItems = (targetDate, eventIdList) => {
    console.log('fetchProgramItems');
    const eventIds = eventIdList.join(',');
    const programGuide = this.props.programGuide;
    const service = this.state.service;
    const channelId = service.original_network_id +'.' +service.transport_stream_id +'.' +service.service_id;
    // http(s)://{EPG}/apps/epg/provider/{nid}.{tsid}.{sid}/events.json?eid={event_ids}
    const url = programGuide.index.base[0] +'/' +channelId +'/events.json?eid=' +eventIds;
    const onLoadPrograms = this.props.onLoadPrograms;
    var self = this;
    $.ajax({
      method:'get',
      url: url,
      dataType: 'json',
      cache: false,
      success: (data) => {
        self.setState({programs: data, targetDate: targetDate})
        onLoadPrograms(data);
      },
      error: (xhr, status, err) => console.error(url, status, err.toString())
    });
  };
  componentDidMount = () => {
    if (this.props.videoType === 'live') {
      this.scrollToLive();
    }
  }
  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.programs != this.state.programs) {
       this.scrollToLive();
    }
  };
  scrollToLive = () => {
    if (this.props.videoType !== 'live') {
      return;
    }
    //const el = this.activeRef.current;
    const el = ReactDOM.findDOMNode(this.refs.active);
    //const el = document.querySelector('.active-program-item');
    //const els = document.getElementsByClassName('active-program-item');
    if (el) {
      //const listRoot = this.listRootRef.current;
      const listRoot = ReactDOM.findDOMNode(this.refs.listRoot);
      //const listRoots = document.getElementsByClassName('listRoot');
      if (listRoot) {
        listRoot.scrollTop = el.offsetTop - 120;
      }
    }

  }
  render = () => {
    const overlay = this.props.overlay;
    if (!overlay || this.props.isFullscreen) {
      return (<div/>);
    }
    const self = this;
    const programs = this.state.programs;
    const services = this.props.services.services;
    const service = this.state.service;
    const groupList = [];
    var itemList = [];
    var groupHour; // HH
    const now = new Date().getTime();
    const subHeaderStyle = {fontSize: 20, lineHeight: 28, padding:4,
      marginBottom:0, color:'white', backgroundColor:grey[700]};
    const dividerStyle = {margin:0, padding: 0};
    const listStyle = { margin: 0, padding: 0};
    var listKey = 0;
    var divKey = 0;
    var itemKey = 0;
    const { classes } = this.props;
    $(programs).each(function(_,i) {
      const program = Object.values(this)[0];
      program.event_id = Object.keys(this)[0];
      const hour = moment(program.start_time * 1000).format('H');
      if (groupHour === undefined) {
        groupHour = hour;
      }
      else if (hour !== groupHour) {
        groupList.push(
          <div key={listKey++} style={listStyle}>
            <ListSubheader style={subHeaderStyle}>
              <Avatar className={classes.avatar}>{groupHour}時</Avatar>
            </ListSubheader>
            {itemList}
          </div>
        );
        groupHour = hour;
        itemList = [];
      }
      // active program
      var isActive =
        self.props.service === self.state.service &&
        ((self.props.videoType === 'timeshift' && self.props.program.start_time === program.start_time) ||
        (self.props.videoType === 'live' && program.start_time*1000 <= now && now < program.end_time*1000));
      const min = moment(program.start_time * 1000).format('mm');
      if (isActive) {
        itemList.push(
          <ListItem
            key={itemKey++}
            style={{backgroundColor:cyan[600], color:'#fff'}}
            ref="active"
          >
            <div key={divKey++} style={{lineHeight:'23px'}}>
              <span style={styles.hour}>{min}</span>
              <span>{program.name}</span>
            </div>
          </ListItem>
        );
      }
      // before program
      else if (program.start_time*1000 < now) {
        itemList.push(
          <ListItem
            key={itemKey++}
            onClick={(e) => {self.props.onSelectProgram(program, service);}}
            style={{cursor:'pointer'}}
          >
            <div key={divKey++} style={{marginRight:8, lineHeight:'23px'}}>
              <span style={styles.hour}>{min}</span>
              <span>{program.name}</span>
            </div>
            <ListItemSecondaryAction>
                <IconButton aria-label="Play"
                  onClick={(e) => {self.props.onSelectProgram(program, service);}}
                  style={{backgroundColor:'rgba(0,128,128,.05)', color: cyan[600]}}
                >
                  <ActionPlay />
                </IconButton>
              </ListItemSecondaryAction>
          </ListItem>
        );
      }
      else {
        itemList.push(
          <ListItem
            key={itemKey++}
          >
          <div key={divKey++} style={{lineHeight:'23px'}}>
            <span style={styles.hour}>{min}</span>
            <span>{program.name}</span>
          </div>
          </ListItem>
        );
      }
      //after program
    });
    groupList.push(
      <div
        key={listKey++}
        style={listStyle}
        >
        <ListSubheader style={subHeaderStyle}>
          <Avatar
            className={classes.avatar}
          >
          {groupHour}時
          </Avatar>
        </ListSubheader>
        {itemList}
      </div>
    );
    const logoImageUrl = service.logo_image_url;
    const backgroundImage = 'url(' + logoImageUrl + ')';
    const tabList = [];
    var tabIndex = 0;
    $(services).each(function(i) {
      const key = 'tab-' + this.remote_control_key_id;
      tabList.push(
        <Tab
          key={key}
          label={this.remote_control_key_id}
          value={i}
          buttonStyle={{color:'#333'}}
        />
      );
      if (service.service_id === this.service_id) {
        tabIndex = i;
      }
    });
    const headerStyle = {
        padding:'4px',
        marginTop:'-25px',
        display:'table',
        width:'362px',
        height:'160px',
        backgroundImage: backgroundImage,
        backgroundSize: '100% auto'
      };
    var divIndex = 0;

    // <Tabs
    //   value={tabIndex}
    //   onChange={this.handleChange}
    //   style={{width:'100%',backgroundColor:'#eee'}}
    // >
    //   {tabList}
    // </Tabs>


    let drawer = <div/>
    //if (this.state.open) {
    if (true) {
      drawer = (<Drawer
        open={this.state.open}
        onClose={() => {this.setState({open:false});this.props.onOverlayFixed(false);}}
        style={{width:370}}
      >
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <div style={headerStyle}>
        <DatePicker
          ref='dp'
          className={classes.datePicker}
          showTodayButton
          value={this.state.targetDate}
          minDate={this.state.minDate}
          maxDate={this.state.maxDate}
          maxDateMessage="Date must be less than today"
          autoOk={true}
          onChange={this.handleDateChange}
          initialFocusedDate={this.state.targetDate}
          format={' MM月DD日(ddd)'}
          style={{zIndex: 2147483647, marginTop: 125, backgroundColor:'rgba(255, 255, 255, 0.5)'}}
          InputProps={{
            endAdornment: (
              <IconButton>
                <EventIcon />
              </IconButton>
            )
          }}
        />
      </div>
      </MuiPickersUtilsProvider>
        <IconButton
          onClick={this.handleClose}
          style={{color:'white', top:0, right:4, position:'absolute'}}
        >
          <CloseIcon />
        </IconButton>

        <div className="listRoot" ref="listRoot" style={{height:'100%', width:370, overflow:'scroll'}}>
          <List key={listKey++} style={listStyle}>
            {groupList}
          </List>
        </div>
      </Drawer>);
    }
    return (
      <div id="programs">
        <IconButton
          style={{left: 0, top: 100, position: 'absolute', minWidth: 40,color:'white'}}
          onClick={this.handleOpenButtonClick}
          onMouseEnter={this.handleMouseEnterOrMouseMove}
          onMouseMove={this.handleMouseEnterOrMouseMove}
          onMouseLeave={this.handleMouseLeave}
          labelStyle={{paddingLeft: 0, paddingRight: 0}}
        >
          <PlaylistPlay />
        </IconButton>
        {drawer}
      </div>
    );
  };
};
class DropDownGenreMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {value: 0};
  }

  handleChange = (event, index, value) => {
    this.setState({value});

  };
  componentDidUpdate = (prevProps, prevState) => {
    $('body > div').last().css('z-index', 2147483647); // 属性指定できないので上書く
  };
  render() {
    return (
      <FormControl>
          <InputLabel htmlFor="genre-select">ジャンル選択</InputLabel>
          <Select
            value={this.state.value}
            onChange={this.handleChange}
            labelStyle={{height: '40px', paddingBottom:0}}
            inputProps={{
              name: 'genre',
              id: 'genre-select',
            }}
            animated={true}
          >
          <MenuItem value={0} primaryText="ジャンル選択" />
          <MenuItem value={1} primaryText="ニュース" />
          <MenuItem value={2} primaryText="Every Night" />
          <MenuItem value={3} primaryText="Weeknights" />
          <MenuItem value={4} primaryText="Weekends" />
          <MenuItem value={5} primaryText="Weekly" />
          </Select>
        </FormControl>
    );
  }
};
export default withStyles(styles)(Programs);



// WEBPACK FOOTER //
// ./src/components/Programs.js